'use client';

import { useEffect, useRef } from 'react';
import { getClient } from '@/lib/supabase/client';
import { clearClientCache } from '@/lib/client-request-cache';

/**
 * 全局监听 Supabase 认证状态
 * 将浏览器中的 Session 同步到 Next.js Route Handlers（Server Components）
 */
export default function SupabaseListener() {
  const supabase = getClient();
  const timeoutRef = useRef(null);

  useEffect(() => {
    const {
      data: { subscription }
    } = supabase.auth.onAuthStateChange(async (event, session) => {
      const shouldSyncSession = ['SIGNED_IN', 'SIGNED_OUT', 'USER_UPDATED', 'TOKEN_REFRESHED'].includes(event);
      if (!shouldSyncSession) return;

      if (['SIGNED_IN', 'SIGNED_OUT', 'USER_UPDATED'].includes(event)) {
        clearClientCache();
      }
      // 防抖：避免短时间多次触发
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(async () => {
        try {
          // 若 session 异常为字符串，则跳过同步（防止双重序列化）
          if (typeof session === 'string') {
            console.warn('SupabaseListener: session is string, skip sync');
            return;
          }

          await fetch('/auth/callback', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({ event, session })
          });

          // 服务端 cookie 同步完成，通知其他组件（如 useVideoTasks）可以安全地发起认证 API 请求
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('supabase:session-synced', {
              detail: { event }
            }));
          }
        } catch (error) {
          console.error('Failed to sync auth session:', error);
        }
      }, 100);
    });

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      subscription.unsubscribe();
    };
  }, [supabase]);

  return null;
}
